import { render, staticRenderFns } from "./UsersPrivilegeQuestionPlan.vue?vue&type=template&id=c168fd30&scoped=true&"
import script from "./UsersPrivilegeQuestionPlan.vue?vue&type=script&lang=js&"
export * from "./UsersPrivilegeQuestionPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c168fd30",
  null
  
)

export default component.exports